module.exports = __webpack_public_path__ + "static/partner1-fcb661e0f49dc1773f0a88b6e2c120c4.png";